import Box from "@mui/joy/Box";
import Stack from "@mui/joy/Stack";
import React from "react";
import { Fact, FactId } from "../../../../../models/fact";
import { CodeableConcept, Quantity } from "../../../../../models/structuration";
import { FactPaper } from "./FactPaper/FactPaper";

interface FactRendererProps {
  readonly facts: Array<Fact>;
  readonly domain: string;
  readonly isFactEditable: boolean;
  readonly displayAnnotations: boolean;
  readonly displayedFactsLength: number;
  readonly onFactClick: (fact: Fact) => void;
  readonly onRemoveFact: (factId: FactId) => void;
  readonly onValueChange: (
    factId: FactId,
    newValue: string | Quantity | CodeableConcept | null
  ) => void;
  readonly onCodeChange: (newCode: CodeableConcept, factId: FactId) => void;
  readonly onRemoveAnnotation: (factId: FactId, offset: number) => void;
}

export function FactRenderer({
  facts,
  domain,
  isFactEditable,
  displayAnnotations,
  displayedFactsLength,
  onFactClick,
  onRemoveFact,
  onValueChange,
  onCodeChange,
  onRemoveAnnotation,
}: FactRendererProps) {
  return (
    <Stack direction="column">
      {facts.map((fact) => (
        <Box
          sx={{ pb: 1 }}
          key={fact.fact_id}
          onClick={() => (!isFactEditable || displayedFactsLength > 1) && onFactClick(fact)}
        >
          <FactPaper
            fact={fact}
            domain={domain}
            isFactEditable={isFactEditable}
            displayAnnotations={displayAnnotations}
            onRemove={() => onRemoveFact(fact.fact_id)}
            onValueChange={(newValue) => onValueChange(fact.fact_id, newValue)}
            onCodeChange={(newCode) => onCodeChange(newCode, fact.fact_id)}
            onRemoveAnnotation={(offset) => onRemoveAnnotation(fact.fact_id, offset)}
          />
        </Box>
      ))}
    </Stack>
  );
}
